import React from "react";
import { Box } from "@material-ui/core";
import ProductDetailsModule from "./Module";
import { makeStyles } from "@material-ui/core/styles";
import { DatoCmsProductVariantFragment_modules_DatoCmsCModulePvImageDescription } from "../../../../../fragments/__generated__/DatoCmsProductVariantFragment";
import Imgix from "react-imgix";

const useStyles = makeStyles(theme => ({
  root: {
    display: `grid`,
    gridGap: theme.spacing(4),
    gridTemplateColumns: `repeat(2, 1fr)`,
    [theme.breakpoints.down(`sm`)]: {
      gridTemplateColumns: `repeat(1, 1fr)`
    },
    width: `100%`,
    margin: `0 auto`
  },
  descriptionHtml: {
    "& ul": {
      paddingLeft: theme.spacing(2)
    },
    "& li": {
      lineHeight: 2
    },
    "& p": {
      fontSize: "1.6rem"
    }
  }
}));

type Props = {
  data: DatoCmsProductVariantFragment_modules_DatoCmsCModulePvImageDescription;
};

const ProductDetailsModuleImageDescription = ({ data }: Props) => {
  const classes = useStyles();
  return (
    <ProductDetailsModule title={data.title}>
      {data?.image?.url && (
        <Box display="flex" justifyContent="center" mb={4}>
          <Imgix
            src={data.image.url}
            height={300}
            htmlAttributes={{
              title: data.image?.title || data.title,
              alt: data.image?.title || data.title,
              loading: "lazy"
            }}
            imgixParams={{
              q: 75,
              auto: "format,compress"
            }}
          />
        </Box>
      )}
      <div
        className={classes.descriptionHtml}
        dangerouslySetInnerHTML={{
          __html: data.descriptionNode.childMarkdownRemark.html
        }}
      />
    </ProductDetailsModule>
  );
};

export default React.memo(ProductDetailsModuleImageDescription);
